import { Paper, Tooltip, Typography } from "@material-ui/core";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import ErrorIcon from "@material-ui/icons/Error";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import React from "react";

import EmptyTableState from "../EmptyTableState/EmptyTableState";
import OrderRow from "../OrderRow/OrderRow";
import useStyles from "./OrdersTable.styles";
import { colors } from "../../tokens";
import { WarningOutlined } from "@material-ui/icons";
import AcuteIcon from "../../Icons/AcuteIcon";

function AlertTitle({ children, tooltip, classes }) {
	return (
		<>
			<Typography className={classes.tableHeaderText}>{children}</Typography>
			<Tooltip
				title={tooltip}
				classes={{ tooltip: classes.customTooltip }}
				placement="top"
			>
				<InfoOutlinedIcon className={classes.infoIcon} />
			</Tooltip>
		</>
	);
}

export default function OrdersTable({ table, type, isEmpty, onRowClick }) {
	const classes = useStyles();
	const HeaderIcon = type === "expiring" ? AcuteIcon : WarningOutlined;

	if (isEmpty) {
		return <EmptyTableState stateKey={type} />;
	}

	return (
		<Paper className={classes.tableCard}>
			<div
				className={classes.tableHeader}
				style={{ backgroundColor: colors.tables[table?.variant] || table?.variant }}
			>
				<HeaderIcon className={classes.headerIcon} />
				<AlertTitle tooltip={table?.infoText} classes={classes}>
					{table?.title}
				</AlertTitle>
			</div>
			<div className={`${classes.tableRow} ${classes.tableHeadRow}`}>
				{table?.columns.map((column, index) => (
					<Typography
						className={`${classes.tableCell} ${classes.tableHeadCell}`}
						key={`${index}-${column}`}
					>
						{column}
					</Typography>
				))}
				<span />
			</div>
			<div className={classes.rowsScroll}>
				{table?.rows.map((row, index) => (
					<OrderRow
						key={`${index}-${row[0]}`}
						className={classes.tableRow}
						columns={row}
						onClick={onRowClick}
					/>
				))}
			</div>
		</Paper>
	);
}
